// extracted by mini-css-extract-plugin
export default {"container":"ParcelDetails_container__rTkE0"};